import {DialogButtonTypesEnum, DialogConfigInterface} from '../../app/shared/components/dialog';

export const AssignSupervisedRightsDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
